import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { DrawerHeader } from 'components/views/Header/components/HelperDrawer/components/DrawerHeader';
import { HelperDrawerBody } from 'components/views/Header/components/HelperDrawer/components/HelperDrawerBody';
import { HEADER_TEXT } from 'components/views/Header/components/HelperDrawer/helpers';
import { HelperDrawerSectionEnum } from 'components/views/Header/components/HelperDrawer/types';

interface Props {
  title?: string;
  isOpen: boolean;
  close: () => void;
  section?: HelperDrawerSectionEnum;
}

export const PageHeaderHelpDialog = ({
  title = 'Help & Support',
  isOpen,
  close,
  section = HelperDrawerSectionEnum.GLOBAL,
}: Props) => {
  if (!isOpen) return null;

  return (
    <ConfirmationDialog isDialogOpen={isOpen} handleCloseDialog={close} dialogTitle={title} hasBottomBar={false}>
      <Grid container spacing={2}>
        <DrawerHeader headerText={HEADER_TEXT[section]} />
        <HelperDrawerBody openContactDialog={() => null} isGuestApp={false} hasContactDialog={false} />
      </Grid>
    </ConfirmationDialog>
  );
};
